import styled from "styled-components";
import { MenuData, AdminMenuData } from '../../../services/menuData'
import NavLink from "../nav-link";

const LinksGroup = styled.div`
  padding: 0px 0px 50px 0px;
  display: flex;
  flex-direction: column;
  flex-grow: ${p => Number(!p.compact)};
  margin-right: 2px;
  overflow: hidden;
  overflow-y: auto;
  background-color: rgba(250, 250, 250, 0.1);
  transition: flex-grow 0.3s cubic-bezier(0.4, 0, 1, 1);
  ::-webkit-scrollbar {
    width: 4px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    // background: rgba(255, 255, 255, 0.4);
    background: grey;
    border-radius: 4px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  @media(max-width: 920px) {
      flex-grow: 1;
  }
`;

const NavLinkGroup = (props) => {
  const isAdmin = window.location.pathname.includes('admin')
  return (
    <LinksGroup {...props}>
      {!isAdmin ? MenuData.map((menu, i) => (
        <NavLink
          key={i}
          toggleNav={props.toggleNav}
          link={menu.to}
          compact={props.compact}
          label={menu.label}
          icon={menu.icon}
        />
      )) : AdminMenuData.map((menu, i) => (
        <NavLink
          key={i}
          toggleNav={props.toggleNav}
          link={menu.to}
          compact={props.compact}
          label={menu.label}
          icon={menu.icon}
        />
      ))}
    </LinksGroup>
  )
}

export default NavLinkGroup
